/** Spreadsheet column AF (0-based index 31) — skater contract/cap hit for FA detection */
export const ROSTER_AF_COLUMN_INDEX = 31;

/** Spreadsheet column Z (0-based index 25) — goalie roster flag on Goalies sheet */
export const ROSTER_GOALIE_Z_COLUMN_INDEX = 25;

export function parseSpreadsheetNumber(value) {
  if (value === undefined || value === null || value === "") return 0;
  if (typeof value === "number") return Number.isFinite(value) ? value : 0;
  return parseFloat(String(value).replace(/[^0-9.-]/g, "")) || 0;
}

/**
 * Resolve team display + free-agent status from column D (team) and column AF.
 * Players with a team name but 0 in AF are treated as free agents.
 */
export function resolveRosterTeamFields(teamName, afValue) {
  const rawTeam = (teamName ?? "").toString().trim();
  const contractAf = parseSpreadsheetNumber(afValue);
  const isFreeAgent = !rawTeam || rawTeam === "N/A" || contractAf === 0;
  const team = !rawTeam || rawTeam === "N/A" ? "Free Agents" : rawTeam;
  return { team, isFreeAgent, contractAf };
}

/**
 * Goalies sheet: column D = team, column Z >= 1 means on roster.
 */
export function resolveGoalieRosterTeamFields(teamName, zValue) {
  const rawTeam = (teamName ?? "").toString().trim();
  const contractZ = parseSpreadsheetNumber(zValue);
  const isFreeAgent = !rawTeam || rawTeam === "N/A" || contractZ === 0;
  const team = !rawTeam || rawTeam === "N/A" ? "Free Agents" : rawTeam;
  return { team, isFreeAgent, contractZ };
}

export function isFreeAgentPlayer(player) {
  if (!player) return false;
  if (player.isFreeAgent !== undefined) return Boolean(player.isFreeAgent);
  return player.team === "Free Agents" || player.team === "N/A";
}
